/**
 * Home detail properties (JSDoc-only export for page imports)
 * @typedef HomeDetail
 * @type {Object}
 * @property {Number} id
 * @property {Number} area
 * @property {Object} project
 * @property {Object} structure
 * @property {Object} address
 * @property {String} transferDate
 * @property {String} createdAt
 * @property {String} updatedAt
 */
export const HomeDetail = {}

/**
 * @typedef HomeInput
 * @type {Object}
 * @property {String} structure     - Construction type
 * @property {String} addressNo     - Address number
 * @property {String} addressRoad   - Address road
 * @property {Number} area          - Usable area
 * @property {String} tumbonPrefix  - Tumbon prefix ('แขวง' or 'ตำบล')
 * @property {String} tumbonName    - Tumbon name
 * @property {String} amphurPrefix  - Amphur prefix ('เขต' or 'อำเภอ')
 * @property {String} amphurName    - Amphur name
 * @property {String} provinceName  - Province name
 * @property {String} zipCode       - Zip code
 * @property {String} transferDate  - Transfer Date (YYYY-MM-DD)
 */

export class NonScHomeCommon {

  /** @type {HomeDetail} */
  static detail = {
    id            : null,
    area          : null,
    project       : null,
    structure     : null,
    address       : null,
    transferDate  : null,
    createdAt     : null,
    updatedAt     : null,
  }
  
  /** @type {HomeInput} */
  static input = {
    structure     : 'บ้านเดี่ยว',
    addressNo     : null,
    addressRoad   : null,
    area          : null,
    tumbonPrefix  : null,
    tumbonName    : null,
    amphurPrefix  : null,
    amphurName    : null,
    provinceName  : null,
    zipCode       : null,
    transferDate  : null,
  }
}